import api from './api'

const roleService = {
  async getRoleWithPermissions(roleId) {
    const response = await api.get(`/role/${roleId}/permissions/`)

    return response.data
  },

  async getRoles() {
    const response = await api.get('/role/')
    return response.data
  },

  async getRoleById(roleId) {
    const response = await api.get(`/role/${roleId}`)
    return response.data
  },

  async createRole(roleData) {
    const response = await api.post('/role/', roleData)
    return response.data
  },

  async updateRole(roleId, roleData) {
    const response = await api.patch(`/role/${roleId}`, roleData)
    return response.data
  },

  async deleteRole(roleId) {
    const response = await api.delete(`/role/${roleId}`)
    return response.data
  },

  async deleteAllRoles() {
    const response = await api.delete('/role/')
    return response.data
  }
}

export default roleService
